import VueRouter from "vue-router";
import index from '@/components/spa/pages/indexComponent.vue';
import about from '@/components/spa/pages/aboutComponent.vue';
import victorine from '@/components/spa/pages/victorineComponent.vue';
import help from '@/components/spa/pages/helpComponent.vue';
import feedback from '@/components/spa/pages/feedbackComponent.vue';
import dict from '@/components/spa/pages/dictComponent.vue';

const routes = [
    { path: '/index', component: index },
    { path: '/about', component: about },
    { path: '/victorine', component: victorine },
    { path: '/help', component: help },
    { path: '/feedback', component: feedback },
    { path: '/dict', component: dict },
  ]
  
export default new VueRouter({
    routes
  })